import React, { Component } from 'react';
import { connect }          from 'react-redux';
import ReactTooltip         from 'react-tooltip';
import { Link }                    from 'react-router-dom';
import { GetMissaoPalavra,
         GetTipoAtividade } from '../../../../actions/atividadesAction';
import FlashCarregando      from '../../../../container/FlashCarregando';
import PalavraList          from './desafios_bomba_list';
import { SetError }         from '../../../../actions/notificacaoAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo,
         ActionModal}       from '../../../../actions/scopoAction';

class QuestaoPalavra extends Component {

    constructor(props){
        super(props);
        this.state = {
            load   : false,
            pal_id : this.props.match.params.id,
            tipo   : "Carregando..."
        }
    }

    componentWillMount() {
        this.props.GetMissaoPalavra(this.state.pal_id).then((response) => {
           this.setState({load:true,tipo: `- ${this.props.GetTipoAtividade(this.props.tipo)}`})
        }).catch((error)=>{
           this.props.SetError(500);
        });

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:this.props.menu.desafios.nomeModulo,link:this.props.menu.desafios.home},
            {action:false,nome:this.props.menu.desafios.jogo.jogo2},
           ]);


        this.props.GetListaSubMenuTopo([]);
    }

    render() {
      
        return (
            <div>
            <div className="container-bg">
            <div className="titulo-pages topo_conteudo">
                  <span className="titulo" data-for='titulo'  data-tip>{this.props.titulo}</span>
                  <ReactTooltip id="titulo" type="dark" effect='solid'>{this.props.turma} / {this.props.disciplina}</ReactTooltip>
                  <div className="pull-right">
                    <Link to={`${this.props.menu.desafios.desafiobombaaction}/${this.state.pal_id}/novo`} className="btn btn-primary pull-right">Cadastrar</Link>
                  </div>
                </div>
            {!this.state.load ? <FlashCarregando/> :  <PalavraList pal_id={this.state.pal_id}/>}
            </div>
        </div>
        );
    }
}

function mapStateToProps(state){

    return {
      menu         : state.configReducer.menu,
      tipo         : state.atividadesReducer.tipo,
      actionModal  : state.scopoReducer.actionModal,
      turma        : state.atividadesReducer.turma,
      titulo       : state.atividadesReducer.titulo,
      disciplina   : state.atividadesReducer.disciplina,
      all_palavras : state.atividadesReducer.fetch_all_palavra
    }
}

export default connect(mapStateToProps,{GetMissaoPalavra,
                                        GetTipoAtividade,
                                        SetError,
                                        GetListaMenuTopo,
                                        GetListaSubMenuTopo,
                                        ActionModal})(QuestaoPalavra);



// WEBPACK FOOTER //
// ./src/components/professor/desafios/bomba/desafios_bomba.js